import React from "react";
import { Icon } from "@chakra-ui/react";
import { ReactComponent as SpeakerIcon } from "../assets/speaker_icon.svg";

type PlaySoundProps = {
  src?: string;
};

const proxy = (url: string) =>
  `${process.env.REACT_APP_API_BASE_URL}/audio?url=${url}`;

export const PlaySound = ({ src }: PlaySoundProps) => {
  if (!src) return <></>;
  return (
    <Icon
      as={SpeakerIcon}
      cursor="pointer"
      onClick={() => new Audio(proxy(src)).play()}
    />
  );
};
